<script>
    /**
     * @typedef {Object} Props
     * @property {string} [label]
     * @property {any} [labelFor]
     * @property {string} [instruction]
     * @property {any} [information]
     * @property {string} [direction]
     * @property {string} [labelAs]
     * @property {any} [id]
     * @property {import('svelte').Snippet} [children]
     * @property {string} [class]
     */
    let {
        label = '',
        labelFor = null,
        instruction = '',
        information = null,
        direction = 'column',
        labelAs = 'label',
        id = null,
        children,
        class: className = '',
        asterix = false,
    } = $props();

    // Handle leading and trailing asterisks
    const showAsteriskBefore = $derived.by(() =>
        typeof label === 'string' && /^\*/.test(label)
    );
    const showAsteriskAfter = $derived.by(() =>
        typeof label === 'string' && /\*$/.test(label) || asterix
    );
    const labelText = $derived.by(() => {
        if (typeof label !== 'string') return label;
        return label.replace(/^\*\s*/, '').replace(/\s*\*$/, '').trim();
    });
</script>


<div class="form-row {direction} {className}">
    {#if label}
        <svelte:element 
            this={labelAs} 
            {id}
            class="label" 
            {...(labelFor !== null ? { for: labelFor } : {})}
        >
            {#if showAsteriskBefore}
                <span class="asterisk right">*</span>
            {/if}
            {labelText}
            {#if showAsteriskAfter}
                <span class="asterisk left">*</span>
            {/if}
            <small>{instruction}</small>
            <div class="spacer"></div>
            {#if information}
                <i class="material-icons interactive information" title={information} aria-hidden="true">info</i>
            {/if}
        </svelte:element>
    {/if}

    {@render children?.()}
</div>

<style>
    .form-row {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
    }

    .row {
        flex-direction: row;
        align-items: flex-start;
        justify-content: flex-start;
        gap: 32px;
    }

    .label {
        display: flex;
        align-items: center;
        text-transform: uppercase;
        font-weight: 600;
        font-size: 0.75rem;
        margin-bottom: 0.5rem;
        color: rgba(255, 255, 255, 0.6);
    }

    .label small {
        font-size: 0.75rem;
        font-weight: 400;
        text-transform: none;
        margin-left: 0.25rem;
        opacity: 0.8;
    }

    .information {
        font-size: 0.9rem;
    }
</style>